var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "box-card", attrs: { shadow: "always" } },
    [
      _c(
        "div",
        { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
        [
          _c("span", [_vm._v("Προσθήκη")]),
          ["Admin", "RegistryAdmin"].includes(_vm.activeRole)
            ? _c("span", [_vm._v("/Τροποποίηση")])
            : _vm._e(),
          _c("span", [_vm._v(": Νέου Πανεπιστημίου")]),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.addUniversity,
                  expression: "addUniversity"
                }
              ],
              staticStyle: {
                float: "right",
                padding: "5px 5px",
                margin: "10px 10px"
              },
              attrs: { type: "text" },
              on: { click: _vm.hideForm }
            },
            [_vm._v("Κλείσιμο")]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text item" },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.deletingUnit,
                  expression: "deletingUnit"
                }
              ],
              attrs: {
                inline: true,
                "inline-message": true,
                "label-width": "130px",
                size: "small"
              }
            },
            [
              ["Admin", "RegistryAdmin"].includes(_vm.activeRole)
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Λειτουργία" } },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": "Προσθήκη",
                          "inactive-text": "Τροποποίηση"
                        },
                        on: { change: _vm.addOrModifyChanged },
                        model: {
                          value: _vm.addOrModify,
                          callback: function($$v) {
                            _vm.addOrModify = $$v
                          },
                          expression: "addOrModify"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("br", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.addOrModify,
                    expression: "!addOrModify"
                  }
                ]
              }),
              ["Admin", "RegistryAdmin"].includes(_vm.activeRole)
                ? _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.addOrModify,
                          expression: "!addOrModify"
                        }
                      ],
                      attrs: { label: "Τροποποίηση σε" }
                    },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          on: { change: _vm.groupChanged },
                          model: {
                            value: _vm.checkboxΙnstitutions,
                            callback: function($$v) {
                              _vm.checkboxΙnstitutions = $$v
                            },
                            expression: "checkboxΙnstitutions"
                          }
                        },
                        _vm._l(_vm.institutions, function(institution) {
                          return _c(
                            "el-checkbox-button",
                            { key: institution, attrs: { label: institution } },
                            [_vm._v(_vm._s(institution))]
                          )
                        })
                      )
                    ],
                    1
                  )
                : _vm._e(),
              ["Admin", "RegistryAdmin"].includes(_vm.activeRole)
                ? _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.addOrModify,
                          expression: "addOrModify"
                        }
                      ],
                      attrs: { label: "Προσθήκη Συνεδρίας", prop: "meeting" }
                    },
                    [
                      _c("el-checkbox", {
                        on: { change: _vm.addMeetingChanged },
                        model: {
                          value: _vm.addMeeting,
                          callback: function($$v) {
                            _vm.addMeeting = $$v
                          },
                          expression: "addMeeting"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("br"),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.gettingMeetings,
                      expression: "gettingMeetings"
                    },
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        !_vm.addOrModify &&
                        _vm.checkboxΙnstitutions[0] === "Συνεδρία",
                      expression:
                        "!addOrModify && checkboxΙnstitutions[0] === 'Συνεδρία'"
                    }
                  ],
                  attrs: { label: "Αρ. Συνεδρίας", prop: "meeting" }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "big",
                      attrs: {
                        "value-key": "id",
                        placeholder: "Όνομα Συνεδρίας",
                        filterable: "filterable",
                        clearable: "clearable"
                      },
                      on: { change: _vm.meetingSelected },
                      model: {
                        value: _vm.meeting,
                        callback: function($$v) {
                          _vm.meeting = $$v
                        },
                        expression: "meeting"
                      }
                    },
                    _vm._l(_vm.meetings, function(meeting) {
                      return _c("el-option", {
                        key: meeting.id,
                        attrs: { label: meeting.meeting_no, value: meeting }
                      })
                    })
                  )
                ],
                1
              ),
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.gettingMeeting,
                      expression: "gettingMeeting"
                    },
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.addMeeting ||
                        (!_vm.addOrModify &&
                          _vm.checkboxΙnstitutions[0] === "Συνεδρία"),
                      expression:
                        "addMeeting || (!addOrModify && checkboxΙnstitutions[0] === 'Συνεδρία')"
                    }
                  ],
                  staticClass: "box-card",
                  attrs: { shadow: "always" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _vm.addOrModify
                        ? _c("span", [_vm._v("Εισάγετε νέα Συνεδρία")])
                        : _c("span", [
                            _vm._v(
                              "Επιλέξτε και Τροποποιήστε την Συνεδρία " +
                                _vm._s(_vm.meeting.meeting_no)
                            )
                          ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.savingMeeting,
                          expression: "savingMeeting"
                        }
                      ],
                      staticClass: "text item"
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Αρ. Συνεδρίας*",
                            prop: "meeting.meeting_no"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "big",
                            attrs: { type: "text", placeholder: "Συνεδρία" },
                            on: {
                              input: function($event) {
                                _vm.meeting.nameInserted = _vm.meeting.nameInserted.toUpperCase()
                              }
                            },
                            model: {
                              value: _vm.meeting.nameInserted,
                              callback: function($$v) {
                                _vm.$set(_vm.meeting, "nameInserted", $$v)
                              },
                              expression: "meeting.nameInserted"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Ημερομηνία Συνεδρίας*",
                            prop: "meeting.meeting_date"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "date",
                              placeholder: "Ημερομηνία Συνεδρίας",
                              format: "dd-MM-yyyy",
                              "value-format": "dd-MM-yyyy"
                            },
                            model: {
                              value: _vm.meeting.meeting_date,
                              callback: function($$v) {
                                _vm.$set(_vm.meeting, "meeting_date", $$v)
                              },
                              expression: "meeting.meeting_date"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Τύπος Συνεδρίας*",
                            prop: "meeting.ds_epitropi"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "big",
                              attrs: {
                                "value-key": "id",
                                placeholder: "Τύπος Συνεδρίας",
                                filterable: "filterable",
                                clearable: "clearable"
                              },
                              model: {
                                value: _vm.meeting.ds_epitropi,
                                callback: function($$v) {
                                  _vm.$set(_vm.meeting, "ds_epitropi", $$v)
                                },
                                expression: "meeting.ds_epitropi"
                              }
                            },
                            _vm._l(_vm.dsEpitropes, function(epi) {
                              return _c("el-option", {
                                key: epi.key,
                                attrs: { label: epi.label, value: epi.value }
                              })
                            })
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Αρμοδιότητα*",
                            prop: "meeting.resp_id"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "big",
                              attrs: {
                                "value-key": "id",
                                placeholder: "Αρμοδιότητα",
                                filterable: "filterable",
                                clearable: "clearable"
                              },
                              model: {
                                value: _vm.meeting.resp_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.meeting, "resp_id", $$v)
                                },
                                expression: "meeting.resp_id"
                              }
                            },
                            _vm._l(_vm.respId, function(resp) {
                              return _c("el-option", {
                                key: resp.key,
                                attrs: { label: resp.label, value: resp.value }
                              })
                            })
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.gettingCountries,
                      expression: "gettingCountries"
                    },
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showAll.country && !_vm.addMeeting,
                      expression: "showAll.country && !addMeeting"
                    }
                  ],
                  attrs: { label: "Χώρα", prop: "country" }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "countries",
                      attrs: {
                        "value-key": "id",
                        placeholder: "Χώρα",
                        filterable: "filterable",
                        clearable: "clearable"
                      },
                      on: {
                        change: _vm.countrySelected,
                        focus: _vm.getCountries
                      },
                      model: {
                        value: _vm.country,
                        callback: function($$v) {
                          _vm.country = $$v
                        },
                        expression: "country"
                      }
                    },
                    [
                      _vm._l(_vm.countries, function(country) {
                        return _c("el-option", {
                          key: country.id,
                          attrs: { label: country.name, value: country }
                        })
                      }),
                      _c("el-option", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.addOrModify &&
                              _vm.activeRole !== "RegistryAdmin",
                            expression:
                              'addOrModify && activeRole !== "RegistryAdmin"'
                          }
                        ],
                        key: _vm.otherValue.name,
                        attrs: {
                          label: _vm.otherValue.name,
                          value: _vm.otherValue
                        }
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.savingCountry || _vm.gettingCountry,
                      expression: "savingCountry || gettingCountry"
                    },
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        (_vm.country.name === "Άλλο" ||
                          (!_vm.addOrModify &&
                            _vm.checkboxΙnstitutions[0] === "Χώρα")) &&
                        !_vm.addMeeting,
                      expression:
                        "(country.name === 'Άλλο'|| (!addOrModify && checkboxΙnstitutions[0] === 'Χώρα')) && !addMeeting"
                    }
                  ],
                  staticClass: "box-card",
                  attrs: { shadow: "always" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _vm.addOrModify
                        ? _c("span", [_vm._v("Εισάγετε νέα Χώρα")])
                        : _c("span", [
                            _vm._v(
                              "Επιλέξτε και Τροποποιήστε την Χώρα " +
                                _vm._s(_vm.country.name)
                            )
                          ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.showAll.country &&
                            !_vm.isEmptyValue(_vm.country.name),
                          expression:
                            "showAll.country && !isEmptyValue(country.name)"
                        }
                      ],
                      staticClass: "text item"
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Όνομα*",
                            prop: "country.nameInserted"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "big",
                            attrs: { placeholder: "Όνομα*" },
                            on: {
                              input: function($event) {
                                _vm.country.nameInserted = _vm.country.nameInserted.toUpperCase()
                              },
                              change: _vm.countryInsertedChanged
                            },
                            model: {
                              value: _vm.country.nameInserted,
                              callback: function($$v) {
                                _vm.$set(_vm.country, "nameInserted", $$v)
                              },
                              expression: "country.nameInserted"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Συντομογραφία",
                            prop: "country.short_name"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "Συντομογραφία" },
                            on: {
                              input: function($event) {
                                _vm.country.short_name = _vm.country.short_name.toUpperCase()
                              }
                            },
                            model: {
                              value: _vm.country.short_name,
                              callback: function($$v) {
                                _vm.$set(_vm.country, "short_name", $$v)
                              },
                              expression: "country.short_name"
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-tooltip", { attrs: { placement: "right" } }, [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _vm._v(
                              "Μέχρι 4 χαρακτήρες με βάση αυτό: https://www.nationsonline.org/oneworld/country_code_list.htm"
                            )
                          ]
                        ),
                        _c("i", { staticClass: "el-icon-question" })
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Προηγ. Όνομα",
                            prop: "country.ex_name"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "Προηγούμενο Όνομα" },
                            on: {
                              input: function($event) {
                                _vm.country.ex_name = _vm.country.ex_name.toUpperCase()
                              }
                            },
                            model: {
                              value: _vm.country.ex_name,
                              callback: function($$v) {
                                _vm.$set(_vm.country, "ex_name", $$v)
                              },
                              expression: "country.ex_name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Έχει πολιτείες",
                            prop: "states_exist"
                          }
                        },
                        [
                          _c("el-checkbox", {
                            on: { change: _vm.statesExistsChanged },
                            model: {
                              value: _vm.states_exist,
                              callback: function($$v) {
                                _vm.states_exist = $$v
                              },
                              expression: "states_exist"
                            }
                          })
                        ],
                        1
                      ),
                      _c("hr", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.addOrModify,
                            expression: "!addOrModify"
                          }
                        ]
                      }),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.addOrModify,
                              expression: "!addOrModify"
                            }
                          ],
                          attrs: { label: "Διαχείριση Πόλεων" }
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-text": "Ναι",
                              "inactive-text": "Όχι"
                            },
                            on: { change: _vm.manageCitiesChanged },
                            model: {
                              value: _vm.manageCities,
                              callback: function($$v) {
                                _vm.manageCities = $$v
                              },
                              expression: "manageCities"
                            }
                          }),
                          _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.manageCities,
                                  expression: "manageCities"
                                },
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.gettingCities,
                                  expression: "gettingCities"
                                }
                              ],
                              attrs: { label: "Επιλέξτε Πόλη" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "big",
                                  attrs: {
                                    "value-key": "id",
                                    placeholder: "Πόλεις",
                                    filterable: "filterable",
                                    clearable: "clearable"
                                  },
                                  on: { change: _vm.cityForCountrySelected },
                                  model: {
                                    value: _vm.city,
                                    callback: function($$v) {
                                      _vm.city = $$v
                                    },
                                    expression: "city"
                                  }
                                },
                                [
                                  _vm._l(_vm.citiesForCountry, function(city) {
                                    return _c("el-option", {
                                      key: city.id,
                                      attrs: { label: city.name, value: city }
                                    })
                                  }),
                                  _c("el-option", {
                                    key: "other",
                                    attrs: { label: "Άλλο", value: "other" }
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-card",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.manageCities &&
                                    (!_vm.isEmptyValue(_vm.city.name) ||
                                      _vm.city === "other"),
                                  expression:
                                    'manageCities && (!isEmptyValue(city.name) || city === "other")'
                                },
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.gettingCity,
                                  expression: "gettingCity"
                                }
                              ],
                              staticClass: "box-card",
                              attrs: { shadow: "always" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "clearfix",
                                  attrs: { slot: "header" },
                                  slot: "header"
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.addModifyTextCity) +
                                        " " +
                                        _vm._s(_vm.city.name) +
                                        " της χώρας " +
                                        _vm._s(_vm.country.name)
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.savingCity,
                                      expression: "savingCity"
                                    }
                                  ],
                                  staticClass: "text item"
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Όνομα",
                                        prop: "city.nameInserted"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { placeholder: "Όνομα" },
                                        on: {
                                          input: function($event) {
                                            _vm.city.nameInserted = _vm.city.nameInserted.toUpperCase()
                                          }
                                        },
                                        model: {
                                          value: _vm.city.nameInserted,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.city,
                                              "nameInserted",
                                              $$v
                                            )
                                          },
                                          expression: "city.nameInserted"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm.city.state &&
                                  _vm.country.states_exist === 1
                                    ? _c(
                                        "el-form-item",
                                        {
                                          directives: [
                                            {
                                              name: "loading",
                                              rawName: "v-loading",
                                              value: _vm.gettingStates,
                                              expression: "gettingStates"
                                            }
                                          ],
                                          attrs: {
                                            label: "Πολιτεία που ανήκει"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                "value-key": "id",
                                                placeholder: "Πολιτείες",
                                                filterable: "filterable",
                                                clearable: "clearable"
                                              },
                                              model: {
                                                value: _vm.city.state,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.city,
                                                    "state",
                                                    $$v
                                                  )
                                                },
                                                expression: "city.state"
                                              }
                                            },
                                            _vm._l(
                                              _vm.statesForCities,
                                              function(state) {
                                                return _c("el-option", {
                                                  key: state.id,
                                                  attrs: {
                                                    label: state.name,
                                                    value: state
                                                  }
                                                })
                                              }
                                            )
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            icon: "el-icon-edit"
                                          },
                                          on: { click: _vm.saveNewCity }
                                        },
                                        [_vm._v("Αποθήκευση Πόλης")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "danger",
                                            icon: "el-icon-delete"
                                          },
                                          on: { click: _vm.deleteCity }
                                        },
                                        [_vm._v("Διαγραφή Πόλης")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                !_vm.addOrModify &&
                                _vm.country.states_exist === 1,
                              expression:
                                "!addOrModify && country.states_exist === 1"
                            }
                          ],
                          attrs: { label: "Διαχείριση Πολιτειών" }
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-text": "Ναι",
                              "inactive-text": "Όχι"
                            },
                            on: { change: _vm.manageStatesChanged },
                            model: {
                              value: _vm.manageStates,
                              callback: function($$v) {
                                _vm.manageStates = $$v
                              },
                              expression: "manageStates"
                            }
                          }),
                          _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.manageStates,
                                  expression: "manageStates"
                                },
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.gettingStates,
                                  expression: "gettingStates"
                                }
                              ],
                              attrs: { label: "Επιλέξτε Πολιτεία" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "big",
                                  attrs: {
                                    "value-key": "id",
                                    placeholder: "Πολιτείες",
                                    filterable: "filterable",
                                    clearable: "clearable"
                                  },
                                  on: { change: _vm.stateSelected },
                                  model: {
                                    value: _vm.state,
                                    callback: function($$v) {
                                      _vm.state = $$v
                                    },
                                    expression: "state"
                                  }
                                },
                                [
                                  _vm._l(_vm.states, function(state) {
                                    return _c("el-option", {
                                      key: state.id,
                                      attrs: { label: state.name, value: state }
                                    })
                                  }),
                                  _c("el-option", {
                                    key: "other",
                                    attrs: { label: "Άλλο", value: "other" }
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-card",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.manageStates &&
                                    (!_vm.isEmptyValue(_vm.state.name) ||
                                      _vm.state === "other"),
                                  expression:
                                    'manageStates && (!isEmptyValue(state.name) || state === "other")'
                                },
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.gettingState,
                                  expression: "gettingState"
                                }
                              ],
                              staticClass: "box-card",
                              attrs: { shadow: "always" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "clearfix",
                                  attrs: { slot: "header" },
                                  slot: "header"
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.addModifyTextState) +
                                        " " +
                                        _vm._s(_vm.state.name) +
                                        " της χώρας " +
                                        _vm._s(_vm.country.name)
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.savingState,
                                      expression: "savingState"
                                    }
                                  ],
                                  staticClass: "text item"
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Όνομα",
                                        prop: "state.nameInserted"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { placeholder: "Όνομα" },
                                        on: {
                                          input: function($event) {
                                            _vm.state.nameInserted = _vm.state.nameInserted.toUpperCase()
                                          }
                                        },
                                        model: {
                                          value: _vm.state.nameInserted,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.state,
                                              "nameInserted",
                                              $$v
                                            )
                                          },
                                          expression: "state.nameInserted"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Συντομογραφία",
                                        prop: "state.abbrv"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { placeholder: "Όνομα" },
                                        on: {
                                          input: function($event) {
                                            _vm.state.abbrv = _vm.state.abbrv.toUpperCase()
                                          }
                                        },
                                        model: {
                                          value: _vm.state.abbrv,
                                          callback: function($$v) {
                                            _vm.$set(_vm.state, "abbrv", $$v)
                                          },
                                          expression: "state.abbrv"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            icon: "el-icon-edit"
                                          },
                                          on: { click: _vm.saveNewState }
                                        },
                                        [_vm._v("Αποθήκευση Πολιτείας")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "danger",
                                            icon: "el-icon-delete"
                                          },
                                          on: { click: _vm.deleteState }
                                        },
                                        [_vm._v("Διαγραφή Πολιτείας")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c("br"),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.gettingUniversities,
                      expression: "gettingUniversities"
                    },
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showAll.university && !_vm.addMeeting,
                      expression: "showAll.university && !addMeeting"
                    }
                  ],
                  attrs: { label: "Πανεπιστήμιο", prop: "universitySelect" }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "big",
                      attrs: {
                        "value-key": "id",
                        placeholder: "Πανεπιστήμια",
                        disabled: _vm.disableUniversity,
                        filterable: "filterable",
                        clearable: "clearable"
                      },
                      on: { change: _vm.universitySelected },
                      model: {
                        value: _vm.universitySelect,
                        callback: function($$v) {
                          _vm.universitySelect = $$v
                        },
                        expression: "universitySelect"
                      }
                    },
                    [
                      _vm._l(_vm.universities, function(university) {
                        return _c("el-option", {
                          key: university.id,
                          attrs: { label: university.name, value: university }
                        })
                      }),
                      _c("el-option", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.addOrModify,
                            expression: "addOrModify"
                          }
                        ],
                        key: "other",
                        attrs: { label: "Άλλο", value: "other" }
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.gettingUniversity,
                      expression: "gettingUniversity"
                    },
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        (_vm.university.name === "other" ||
                          (!_vm.addOrModify &&
                            _vm.checkboxΙnstitutions[0] === "Πανεπιστήμιο")) &&
                        !_vm.addMeeting,
                      expression:
                        "(university.name === 'other'|| (!addOrModify && checkboxΙnstitutions[0] === 'Πανεπιστήμιο')) && !addMeeting"
                    }
                  ],
                  staticClass: "box-card",
                  attrs: { shadow: "always" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _vm.addOrModify
                        ? _c("span", [
                            _vm._v(
                              "Εισάγετε νέο Πανεπιστήμιο για την χώρα " +
                                _vm._s(_vm.country.name)
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              "Επιλέξτε και Τροποποιήστε το Πανεπιστήμιο " +
                                _vm._s(_vm.university.name) +
                                " της χώρας " +
                                _vm._s(_vm.country.name)
                            )
                          ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.showAll.university &&
                            !_vm.isEmptyValue(_vm.university.name),
                          expression:
                            "showAll.university && !isEmptyValue(university.name)"
                        }
                      ],
                      staticClass: "text item"
                    },
                    [
                      _vm.addOrModify
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Όνομα*",
                                prop: "university.nameInserted"
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "big",
                                attrs: { type: "text", placeholder: "Όνομα" },
                                on: {
                                  change: _vm.universityInsertedChanged,
                                  input: function($event) {
                                    _vm.university.nameInserted = _vm.university.nameInserted.toUpperCase()
                                  }
                                },
                                model: {
                                  value: _vm.university.nameInserted,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.university,
                                      "nameInserted",
                                      $$v
                                    )
                                  },
                                  expression: "university.nameInserted"
                                }
                              })
                            ],
                            1
                          )
                        : _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Νέο Όνομα*",
                                prop: "university.nameInserted"
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "big",
                                attrs: { type: "text", placeholder: "Όνομα" },
                                on: {
                                  change: _vm.universityInsertedChanged,
                                  input: function($event) {
                                    _vm.university.nameInserted = _vm.university.nameInserted.toUpperCase()
                                  }
                                },
                                model: {
                                  value: _vm.university.nameInserted,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.university,
                                      "nameInserted",
                                      $$v
                                    )
                                  },
                                  expression: "university.nameInserted"
                                }
                              })
                            ],
                            1
                          ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Προηγ. Όνομα1",
                            prop: "university.ex_name"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "ex_name" },
                            on: {
                              input: function($event) {
                                _vm.university.ex_name = _vm.university.ex_name.toUpperCase()
                              }
                            },
                            model: {
                              value: _vm.university.ex_name,
                              callback: function($$v) {
                                _vm.$set(_vm.university, "ex_name", $$v)
                              },
                              expression: "university.ex_name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Προηγ. Όνομα2",
                            prop: "university.ex_name1"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "ex_name1" },
                            on: {
                              input: function($event) {
                                _vm.university.ex_name1 = _vm.university.ex_name1.toUpperCase()
                              }
                            },
                            model: {
                              value: _vm.university.ex_name1,
                              callback: function($$v) {
                                _vm.$set(_vm.university, "ex_name1", $$v)
                              },
                              expression: "university.ex_name1"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Παν/μιο?",
                            prop: "university.university_type_status"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "Τύπος",
                                filterable: "filterable",
                                clearable: "clearable"
                              },
                              model: {
                                value: _vm.university.university_type_status,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.university,
                                    "university_type_status",
                                    $$v
                                  )
                                },
                                expression: "university.university_type_status"
                              }
                            },
                            [
                              _c("el-option", {
                                key: "Y",
                                attrs: { label: "Ναι", value: "Y" }
                              }),
                              _c("el-option", {
                                key: "N",
                                attrs: { label: "Άλλο Ίδρυμα", value: "N" }
                              }),
                              _c("el-option", {
                                key: "E",
                                attrs: { label: "Επιτροπή", value: "E" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Αναγνώριση*",
                            prop: "university.sync_mitroa_recognition_status"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "Κατάσταση",
                                filterable: "filterable",
                                clearable: "clearable"
                              },
                              on: { change: _vm.onRecognitionStatusChanged },
                              model: {
                                value:
                                  _vm.university.sync_mitroa_recognition_status,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.university,
                                    "sync_mitroa_recognition_status",
                                    $$v
                                  )
                                },
                                expression:
                                  "university.sync_mitroa_recognition_status"
                              }
                            },
                            [
                              _c("el-option", {
                                key: "recognized",
                                attrs: {
                                  label: "Αναγνωρισμένο",
                                  value: "recognized"
                                }
                              }),
                              _c("el-option", {
                                key: "unrecognized",
                                attrs: {
                                  label: "Μη αναγνωριστέο",
                                  value: "unrecognized"
                                }
                              }),
                              _c("el-option", {
                                key: "under_review",
                                attrs: {
                                  label: "Μη κριθέν",
                                  value: "under review"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Αρ. Συνεδρίας",
                            prop: "university.meeting"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "big",
                              attrs: {
                                "value-key": "id",
                                placeholder: "Αριθμός Συνεδρίας",
                                filterable: "filterable"
                              },
                              model: {
                                value: _vm.university.meeting,
                                callback: function($$v) {
                                  _vm.$set(_vm.university, "meeting", $$v)
                                },
                                expression: "university.meeting"
                              }
                            },
                            _vm._l(_vm.meetings, function(meeting) {
                              return _c("el-option", {
                                key: meeting.id,
                                attrs: {
                                  label: meeting.meeting_no,
                                  value: meeting
                                }
                              })
                            })
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Αρ. Πράξης",
                            prop: "university.epitropi_id"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "epitropi_id" },
                            on: {
                              input: function($event) {
                                _vm.university.epitropi_id = _vm.university.epitropi_id.toUpperCase()
                              }
                            },
                            model: {
                              value: _vm.university.epitropi_id,
                              callback: function($$v) {
                                _vm.$set(_vm.university, "epitropi_id", $$v)
                              },
                              expression: "university.epitropi_id"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Ενεργό*", prop: "university.active" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "Ενεργό",
                                filterable: "filterable",
                                clearable: "clearable"
                              },
                              model: {
                                value: _vm.university.active,
                                callback: function($$v) {
                                  _vm.$set(_vm.university, "active", $$v)
                                },
                                expression: "university.active"
                              }
                            },
                            [
                              _c("el-option", {
                                key: "Y",
                                attrs: { label: "Ναι", value: "Y" }
                              }),
                              _c("el-option", {
                                key: "N",
                                attrs: { label: "Όχι", value: "N" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Τύπος", prop: "university.type" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "Τύπος",
                                filterable: "filterable",
                                clearable: "clearable"
                              },
                              model: {
                                value: _vm.university.type,
                                callback: function($$v) {
                                  _vm.$set(_vm.university, "type", $$v)
                                },
                                expression: "university.type"
                              }
                            },
                            [
                              _c("el-option", {
                                key: "N",
                                attrs: { label: "", value: "" }
                              }),
                              _c("el-option", {
                                key: "S",
                                attrs: { label: "Κρατικό", value: "S" }
                              }),
                              _c("el-option", {
                                key: "P",
                                attrs: { label: "Ιδιωτικό", value: "P" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Διεύθυνση",
                            prop: "university.address"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "Διεύθυνση" },
                            on: {
                              input: function($event) {
                                _vm.university.address = _vm.university.address.toUpperCase()
                              }
                            },
                            model: {
                              value: _vm.university.address,
                              callback: function($$v) {
                                _vm.$set(_vm.university, "address", $$v)
                              },
                              expression: "university.address"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.gettingCities,
                              expression: "gettingCities"
                            }
                          ],
                          attrs: { label: "Πόλη", prop: "university.city" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "Πόλη",
                                disabled: _vm.disableCities,
                                "value-key": "id",
                                filterable: "filterable",
                                clearable: "clearable"
                              },
                              on: { change: _vm.citySelected },
                              model: {
                                value: _vm.university.city,
                                callback: function($$v) {
                                  _vm.$set(_vm.university, "city", $$v)
                                },
                                expression: "university.city"
                              }
                            },
                            _vm._l(_vm.cities, function(cit) {
                              return _c("el-option", {
                                key: cit.id,
                                attrs: { label: cit.name, value: cit }
                              })
                            })
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Πολιτεία",
                            prop: "university.states"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "Πολιτεία",
                                disabled: _vm.disableUniState,
                                "value-key": "id",
                                filterable: "filterable",
                                clearable: "clearable"
                              },
                              on: { change: _vm.uniStateSelected },
                              model: {
                                value: _vm.university.states,
                                callback: function($$v) {
                                  _vm.$set(_vm.university, "states", $$v)
                                },
                                expression: "university.states"
                              }
                            },
                            _vm._l(_vm.states, function(state) {
                              return _c("el-option", {
                                key: state.id,
                                attrs: { label: state.name, value: state }
                              })
                            })
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Τηλέφωνο1",
                            prop: "university.phone"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "Αριθμός" },
                            model: {
                              value: _vm.university.phone,
                              callback: function($$v) {
                                _vm.$set(_vm.university, "phone", $$v)
                              },
                              expression: "university.phone"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Τηλέφωνο2",
                            prop: "university.other_phone"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "Αριθμός άλλος" },
                            model: {
                              value: _vm.university.other_phone,
                              callback: function($$v) {
                                _vm.$set(_vm.university, "other_phone", $$v)
                              },
                              expression: "university.other_phone"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Αριθμός fax",
                            prop: "university.fax_no"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "Αριθμός fax" },
                            model: {
                              value: _vm.university.fax_no,
                              callback: function($$v) {
                                _vm.$set(_vm.university, "fax_no", $$v)
                              },
                              expression: "university.fax_no"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Email", prop: "university.email" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "email" },
                            model: {
                              value: _vm.university.email,
                              callback: function($$v) {
                                _vm.$set(_vm.university, "email", $$v)
                              },
                              expression: "university.email"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Μη Παν/κό Ίδρυμα",
                            prop: "university.non_universities_type_id"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "non_universities_type_id" },
                            on: {
                              input: function($event) {
                                _vm.university.non_universities_type_id = _vm.university.non_universities_type_id.toUpperCase()
                              }
                            },
                            model: {
                              value: _vm.university.non_universities_type_id,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.university,
                                  "non_universities_type_id",
                                  $$v
                                )
                              },
                              expression: "university.non_universities_type_id"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Για Διαδίκτυο",
                            prop: "university.h_internet"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "commentText commentText",
                            attrs: {
                              type: "textarea",
                              placeholder: "h_internet"
                            },
                            on: {
                              input: function($event) {
                                _vm.university.h_internet = _vm.university.h_internet.toUpperCase()
                              }
                            },
                            model: {
                              value: _vm.university.h_internet,
                              callback: function($$v) {
                                _vm.$set(_vm.university, "h_internet", $$v)
                              },
                              expression: "university.h_internet"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Σχόλια:" } },
                        [
                          _c("el-input", {
                            staticClass: "commentText",
                            attrs: {
                              type: "textarea",
                              placeholder: "Εισάγετε εσωτερικό σχόλιο",
                              size: "100",
                              autosize: { minRows: 4, maxRows: 10 }
                            },
                            model: {
                              value: _vm.university.comments,
                              callback: function($$v) {
                                _vm.$set(_vm.university, "comments", $$v)
                              },
                              expression: "university.comments"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "new-institutes-section" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Τύπος Ιδρύματος" } },
                            [_c("span", [_vm._v("Νέο")])]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Δικαιόχρηση*",
                                prop:
                                  "university.sync_mitroa_is_parent_franchise"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "Επιλέξτε",
                                    filterable: "filterable",
                                    clearable: "clearable"
                                  },
                                  model: {
                                    value:
                                      _vm.university
                                        .sync_mitroa_is_parent_franchise,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.university,
                                        "sync_mitroa_is_parent_franchise",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "university.sync_mitroa_is_parent_franchise"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    key: "1",
                                    attrs: { label: "Ναι", value: 1 }
                                  }),
                                  _c("el-option", {
                                    key: "0",
                                    attrs: { label: "Όχι", value: 0 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "new-institute-full-field" },
                            [
                              _c("label", [_vm._v("Ελληνική Ονομασία")]),
                              _c("el-input", {
                                attrs: { placeholder: "Ελληνική ονομασία" },
                                on: {
                                  input: function($event) {
                                    _vm.university.sync_mitroa_institute_el = _vm.university.sync_mitroa_institute_el.toUpperCase()
                                  }
                                },
                                model: {
                                  value:
                                    _vm.university.sync_mitroa_institute_el,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.university,
                                      "sync_mitroa_institute_el",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "university.sync_mitroa_institute_el"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "new-institute-full-field" },
                            [
                              _c("label", [_vm._v("Πρωτότυπη Ονομασία")]),
                              _c("el-input", {
                                attrs: { placeholder: "Πρωτότυπη ονομασία" },
                                on: {
                                  input: function($event) {
                                    _vm.university.sync_mitroa_institute_original = _vm.university.sync_mitroa_institute_original.toUpperCase()
                                  }
                                },
                                model: {
                                  value:
                                    _vm.university
                                      .sync_mitroa_institute_original,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.university,
                                      "sync_mitroa_institute_original",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "university.sync_mitroa_institute_original"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "new-institute-full-field" },
                            [
                              _c("label", [_vm._v("Σύνδεσμος (URL)")]),
                              _c("el-input", {
                                attrs: { placeholder: "URL" },
                                model: {
                                  value: _vm.university.sync_mitroa_url,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.university,
                                      "sync_mitroa_url",
                                      $$v
                                    )
                                  },
                                  expression: "university.sync_mitroa_url"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "new-institute-full-field" },
                            [
                              _c("label", [_vm._v("Πληροφορίες")]),
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  placeholder: "Πληροφορίες",
                                  autosize: { minRows: 2, maxRows: 6 }
                                },
                                model: {
                                  value: _vm.university.sync_mitroa_info,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.university,
                                      "sync_mitroa_info",
                                      $$v
                                    )
                                  },
                                  expression: "university.sync_mitroa_info"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "compact-form-item",
                              attrs: {
                                label: "Προηγ. Τίτλος Ιδρύματος 1",
                                prop: "university.sync_mitroa_institute_old_1"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Προηγούμενη ονομασία 1"
                                },
                                on: {
                                  input: function($event) {
                                    _vm.university.sync_mitroa_institute_old_1 = _vm.university.sync_mitroa_institute_old_1.toUpperCase()
                                  }
                                },
                                model: {
                                  value:
                                    _vm.university.sync_mitroa_institute_old_1,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.university,
                                      "sync_mitroa_institute_old_1",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "university.sync_mitroa_institute_old_1"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "compact-form-item",
                              attrs: {
                                label: "Προηγ. Τίτλος Ιδρύματος 2",
                                prop: "university.sync_mitroa_institute_old_2"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Προηγούμενη ονομασία 2"
                                },
                                on: {
                                  input: function($event) {
                                    _vm.university.sync_mitroa_institute_old_2 = _vm.university.sync_mitroa_institute_old_2.toUpperCase()
                                  }
                                },
                                model: {
                                  value:
                                    _vm.university.sync_mitroa_institute_old_2,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.university,
                                      "sync_mitroa_institute_old_2",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "university.sync_mitroa_institute_old_2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-edit",
                        disabled: _vm.isSaveDisabled
                      },
                      on: { click: _vm.saveNewUni }
                    },
                    [_vm._v(_vm._s(_vm.saveButtonText))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        icon: "el-icon-delete",
                        disabled: _vm.disableDelete
                      },
                      on: { click: _vm.deleteUni }
                    },
                    [_vm._v("Διαγραφή " + _vm._s(_vm.checkboxΙnstitutions[0]))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41d572d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41d572d6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/ManageNewInstitutes.vue
// module id = null
// module chunks = 